/** Cursor-paginated list page (matches backend ``PageOut``). */

export interface Page<T> {
  items: T[];
  next_cursor: string | null;
  has_more: boolean;
}

const DEFAULT_MAX_ITEMS = 2_000;
const DEFAULT_MAX_PAGES = 25;

/** Fetch pages until ``has_more`` is false or caps are hit. */
export async function fetchAllPages<T>(
  fetchPage: (cursor?: string) => Promise<Page<T>>,
  options: { maxItems?: number; maxPages?: number } = {},
): Promise<{ items: T[]; truncated: boolean }> {
  const maxItems = options.maxItems ?? DEFAULT_MAX_ITEMS;
  const maxPages = options.maxPages ?? DEFAULT_MAX_PAGES;
  const all: T[] = [];
  let cursor: string | undefined;
  let truncated = false;

  for (let pageNum = 0; pageNum < maxPages && all.length < maxItems; pageNum++) {
    const page = await fetchPage(cursor);
    all.push(...page.items);
    if (!page.has_more || !page.next_cursor) {
      break;
    }
    if (all.length >= maxItems) {
      truncated = true;
      break;
    }
    cursor = page.next_cursor;
    if (pageNum === maxPages - 1) {
      truncated = true;
    }
  }

  return { items: all.slice(0, maxItems), truncated };
}
